import { EmptyState } from '@/components/custom/empty-state';

export const CourseClassroomExamDisapproved = props => {
  const { unfinishedExam } = props;

  return (
    <EmptyState
      variant="plain"
      type="disapproved"
      title="Você não atingiu a nota de corte"
      text="Para refazer a prova, basta clicar no botão abaixo. Boa sorte!"
      cta={{ text: 'Refazer a prova', onClick: () => navigate(`/avaliacoes/sobre/${unfinishedExam?.id}`) }}
    />
  );
};
